<faxe-page-layout showClock=true>
  <form [formGroup]="formGroup">

    <mat-card appearance="outlined" class="ctx-large">
      <faxe-page-title></faxe-page-title>

      <faxe-import-race-data>

      </faxe-import-race-data>

    </mat-card>


  </form>
</faxe-page-layout>



